import { call, put, takeEvery } from 'redux-saga/effects';
import {
  getTariffTypes,
  getTariffTypesSuccess,
  getTariffTypesFailure,
  getTariffFeePeriods,
  getTariffFeePeriodsSuccess,
  getTariffFeePeriodsFailure,
  getTariffPrices,
  getTariffPricesSuccess,
  getTariffPricesFailure,
  getTariffPrice,
  getTariffPriceSuccess,
  getTariffPriceFailure,
} from '../../actions/Tariff';
import { getTariffTypesRequest } from '../../../api/requests/Tariff/getTariffTypes';
import { getTariffPricesRequest } from '../../../api/requests/Tariff/getTariffPrices';
import { getTariffFeePeriodsRequest } from '../../../api/requests/Tariff/getTariffFeePeriods';
import { getTariffPriceRequest } from '../../../api/requests/Tariff/getTariffPrice';

function* getTariffTypesSaga(action) {
  try {
    const { payload } = action;
    const response = yield call(getTariffTypesRequest, payload);
    yield put(getTariffTypesSuccess(response));
  } catch (e) {
    yield put(getTariffTypesFailure(e));
  }
}

function* getTariffFeePeriodsSaga(action) {
  try {
    const { payload } = action;
    const response = yield call(getTariffFeePeriodsRequest, payload);
    yield put(getTariffFeePeriodsSuccess(response));
  } catch (e) {
    yield put(getTariffFeePeriodsFailure(e));
  }
}
function* getTariffPricesSaga(action) {
  try {
    const { payload } = action;
    const response = yield call(getTariffPricesRequest, payload);
    yield put(getTariffPricesSuccess(response));
  } catch (e) {
    yield put(getTariffPricesFailure(e));
  }
}

function* getTariffPriceSaga(action) {
  try {
    const { payload } = action;
    const response = yield call(getTariffPriceRequest, payload);
    yield put(getTariffPriceSuccess(response));
  } catch (e) {
    yield put(getTariffPriceFailure(e));
  }
}

export function* tariffWatcher() {
  yield takeEvery(getTariffTypes.toString(), getTariffTypesSaga);
  yield takeEvery(getTariffFeePeriods.toString(), getTariffFeePeriodsSaga);
  yield takeEvery(getTariffPrices.toString(), getTariffPricesSaga);
  yield takeEvery(getTariffPrice.toString(), getTariffPriceSaga);
}
